<template>
    <div class="tw:bg-[linear-gradient(180deg,rgba(15,23,42,0.05),rgba(255,255,255,0)_28%)]">
        <section class="tw:mx-auto tw:w-full tw:max-w-6xl tw:px-4 tw:py-8 sm:tw:px-6 lg:tw:px-8">
            <div class="tw:space-y-6">
                <div class="tw:flex tw:items-center tw:justify-between tw:mb-6">
                    <h2 class="tw:text-xl tw:font-bold tw:text-slate-900 tw:m-0">{{ $t('perfil.cesion_titulo_ceder') }}</h2>
                    <Button variant="default" @click="goBack">
                        <i class="material-icons tw:text-sm">arrow_back</i>
                        {{ $t('perfil.volver') }}
                    </Button>
                </div>

                <div class="tw:grid tw:gap-6 lg:tw:grid-cols-1">
                    <div class="tw:space-y-6">
                        <div class="tw:overflow-hidden tw:rounded-[32px] tw:border tw:border-slate-200 tw:bg-white tw:p-5 tw:shadow-[0_26px_70px_-42px_rgba(15,23,42,0.45)] sm:tw:p-6">
                            <p class="tw:text-xs tw:font-black tw:uppercase tw:tracking-[0.36em] tw:text-slate-400">
                                {{ $t('perfil.cesion_titulo_ceder') }}
                            </p>
                            <h1 class="tw:mt-3 tw:max-w-3xl tw:text-2xl tw:font-black tw:tracking-tight tw:text-slate-950 sm:tw:text-4xl">
                                {{ $t('perfil.cesion_header') }}
                            </h1>
                            <p class="tw:mt-4 tw:max-w-2xl tw:text-sm tw:text-slate-500 sm:tw:text-base">
                                {{ $t('perfil.cesion_instruccion') }}
                            </p>

                            <div class="tw:mt-6 tw:flex tw:flex-wrap tw:gap-3">
                                <span class="tw:inline-flex tw:max-w-full tw:items-center tw:gap-2 tw:rounded-full tw:bg-slate-100 tw:px-4 tw:py-2 tw:text-sm tw:font-medium tw:text-slate-600">
                                    <i class="material-icons tw:text-base">sports_soccer</i>
                                    <span class="tw:min-w-0 tw:break-words">{{ hasEventos ? $t('perfil.cesion_eventos_disponibles', { count: eventos.length }) : $t('perfil.cesion_sin_eventos') }}</span>
                                </span>
                                <span class="tw:inline-flex tw:max-w-full tw:items-center tw:gap-2 tw:rounded-full tw:bg-emerald-50 tw:px-4 tw:py-2 tw:text-sm tw:font-medium tw:text-emerald-700">
                                    <i class="material-icons tw:text-base">verified_user</i>
                                    <span class="tw:min-w-0 tw:break-words">{{ $t('perfil.cesion_gestion_directa') }}</span>
                                </span>
                            </div>
                        </div>

                        <EventList
                            :eventos="eventos"
                            :loading="loadingEventos"
                            :error="errorEventos"
                            :selection-loading="loadingEvento"
                            :selection-error="errorEvento"
                            :selection-error-evento-id="selectionErrorEventoId"
                            :resolving-evento-id="resolvingEventoId"
                            :expanded-evento-id="expandedEventoId"
                            :expanded-sessions="expandedSessions"
                            @select-evento="onSelectEvento"
                            @select-session="onSelectSession"
                            @retry="loadEventos"
                        />
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script setup>
    import { ref, onMounted, computed } from 'vue';
    import EventList from '@/modules/front/perfil/components/cesion/EventList.vue';
    import Button from '@/modules/front/ui/Button.vue';
    import { useCesionAsiento } from '@/composables/front/perfil/useCesionAsiento';
    import { useCesionEventSelection } from '@/composables/front/perfil/useCesionEventSelection';
    import { useRoute } from '@/composables/common/router/useRouter';
    import router from '@/router';

    const $route = useRoute();

    const abonadoIdRef = ref($route.params.abono_id);

    const {
        eventos,
        loadingEventos,
        errorEventos,
        loadEventos,
        onSelectEventoFromList,
        selectSessionFromPicker,
        eventoWithMultipleSessions,
        showSessionPicker,
        loadingEvento,
        errorEvento,
        selectedEvento,
    } = useCesionAsiento(abonadoIdRef);

    const {
        resolvingEventoId,
        expandedEventoId,
        selectionErrorEventoId,
        expandedSessions,
        onSelectEvento,
        onSelectSession,
    } = useCesionEventSelection({
        abonadoId: abonadoIdRef,
        router,
        selectedEvento,
        eventoWithMultipleSessions,
        showSessionPicker,
        errorEvento,
        onSelectEventoFromList,
        selectSessionFromPicker,
    });

    const hasEventos = computed(() => Array.isArray(eventos.value) && eventos.value.length > 0);
    const goBack = () => {
        router.back();
    };

    onMounted(() => {
        loadEventos();
    });
</script>
